// extracted by mini-css-extract-plugin
export default {"arrowBtnRotate":"lX4AkU","footer":"ZS_o_g"};